import React from 'react';
import { ArrowLeftIcon } from 'icons';
import { GetStaticProps } from 'next';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

import { formatSubject, globalConst } from 'modules/global';
import { Main } from 'modules/national-certificate-subject';

import { NextHead } from 'components';

const Index = () => {
  const t = useTranslations();
  const { query } = useRouter();

  return (
    <>
      <NextHead
        title={t('meta.national_certificate_subject.title', { subject: formatSubject(query?.subject as string) })}
        description={t('meta.national_certificate_subject.description', {
          subject: formatSubject(query?.subject as string)
        })}
      />

      <div className="max-w-screen mx-auto my-9 min-h-screen p-3 lg:p-0">
        <Link href={globalConst.pageNames.NATIONAL_CERTIFICATE}>
          <div className="m-4 inline-flex cursor-pointer items-center justify-start gap-2 font-semibold sm:m-0">
            <ArrowLeftIcon /> {t('common.ortga_qaytish')}
          </div>
        </Link>
        <Main />
      </div>
    </>
  );
};

export default Index;

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: {
    messages: (await import(`../../messages/${locale}.json`)).default
  }
});

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking'
  };
}
